import React from 'react';

export function SwitchOn({
  backgroundFill = '#0369E0',
  circleFill = '#fff'
}) {
  return (
    <svg width="36" height="22" viewBox="0 0 36 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
        d="M36 10C36 4.47715 31.5228 0 26 0H10C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20H26C31.5228 20 36 15.5228 36 10Z"
        fill={backgroundFill} />
      <g filter="url(#switchOnFilter)">
        <path fillRule="evenodd" clipRule="evenodd"
          d="M26 18C21.5817 18 18 14.4183 18 10C18 5.58172 21.5817 2 26 2C30.4183 2 34 5.58172 34 10C34 14.4183 30.4183 18 26 18Z"
          fill={circleFill} />
      </g>
      <defs>
        <filter id="switchOnFilter" x="16" y="2" width="20" height="20" filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}

export function SwitchOff({
  backgroundFill = '#BEC0CB',
  circleFill = '#ffffff'
}) {
  return (
    <svg width="36" height="22" viewBox="0 0 36 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
        d="M36 10C36 4.47715 31.5228 0 26 0H10C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20H26C31.5228 20 36 15.5228 36 10Z"
        fill={backgroundFill} />
      <g filter="url(#switchOffFilter)">
        <path fillRule="evenodd" clipRule="evenodd"
          d="M10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18Z"
          fill={circleFill} />
      </g>
      <defs>
        <filter id="switchOffFilter" x="0" y="2" width="20" height="20" filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}